import React from "react";
import { useNavigate } from "react-router-dom";
import bredcrumbs_icon from "../../assets/images/bredcrumbs_icon.svg";

function EditAction({ clientData, onUpdate, isProfile = false, isLoading = false }) {
  const navigate = useNavigate();

  return (
    <div className="inner_bredcrumbs_action bg-transparent">
      <div className="container-fluid bg-transparent">
        <div className="row justify-content-center align-items-center py_14">
          <div className="col-md-6">
            <ul className="bredcrumbs d-flex align-items-center bg-transparent">
              <li>
                {isProfile ? <span>Profile</span> :
                  <span>{clientData.roleName == "Client" ? "Client List" : clientData.roleName == "Company" ? "Company List" : "Employee List"}</span>
                }
              </li>
              <li>
                <img src={bredcrumbs_icon} alt=">" />
              </li>
              <li>
                <span className="active">{clientData?.name || "Client"}</span>
              </li>
            </ul>
          </div>
          <div className="col-md-6">
            <div className="d-flex ms-auto w-100">
              <button
                className="btn btn_secondary mr_10 ms-auto"
                onClick={() => {
                  const path = clientData.roleName === "Company" ? "/companies" : clientData.roleName === "Client" ? "/client" : "/dashboard";
                  navigate(path);
                }}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button className="btn btn_primary" onClick={onUpdate} disabled={isLoading}>
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Updating
                  </>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditAction;
